import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'op-standard-schedule-information',
    templateUrl: './standard-schedule-information.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StandardScheduleInformationComponent {}